import ColorButton from "components/common/ColorButton";
import { RoleId } from "libs/configs/constant";
import useModalLoading from "libs/hooks/useModalLoading";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { canEditForm } from "redux/modules/authSlice";
import { setSmartFormBackStep } from "redux/modules/uiSlice";

export default function ButtonController({
  hideSaveDraft = false,
  hideSubmit = false,
  isDisabledSaveDraftButton = false,
  isDisabledNextButton = false,
  isExtend = false,
  nextButtonText = "Next",
  smartId,
  onClickSaveDraft = () => { },
  onClickNext = () => { },
  onClickSubmit = () => { },
  lastpage = false,
  onClickBack = () => { },
  onClickSave = () => { },
  isLTR = false,
  statusId,
  isSubmitPreapprove = false,
  buttonRef,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { showLoading, hideLoading } = useModalLoading();
  const canEdit = useSelector(canEditForm);
  // const { role } = useSelector((state) => state.auth);
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  if (isExtend) {
    return (
      <div
        style={{
          marginTop: 34,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="outlined"
          color="error"
          type="button"
          onClick={() => {
            isLTR ? onClickBack() : dispatch(setSmartFormBackStep());
          }}
        >
          Back
        </ColorButton>
        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="outlined"
          color="primary"
          disabled={isDisabledSaveDraftButton}
          onClick={onClickSaveDraft}
        >
          {Role === RoleId.Admin ? "Save" : "Save Draft"}
        </ColorButton>

        <ColorButton
          style={{ height: 40, width: 125, marginLeft: 20 }}
          variant="contained"
          color="primary"
          type="submit"
          disabled={isDisabledNextButton}
          onClick={() => {
            window.scrollTo(0, 0);
            onClickNext();
          }}
        >
          {nextButtonText}
        </ColorButton>
      </div>
    );
  }

  return (
    <div
      style={{
        marginTop: 34,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <ColorButton
        style={{ height: 40, width: 125, marginLeft: 20 }}
        variant="outlined"
        color="error"
        type="button"
        onClick={() => {
          isLTR ? onClickBack() : dispatch(setSmartFormBackStep());
        }}
      >
        Back
      </ColorButton>

      {(statusId === "RVW" || Role === RoleId.Admin || statusId === "RPA") &&
        isSubmitPreapprove &&
        canEdit && (
          <ColorButton
            style={{ height: 40, width: 125, marginLeft: 20 }}
            variant="outlined"
            color="primary"
            disabled={isDisabledSaveDraftButton}
            innerRef={buttonRef}
            onClick={() => {
              onClickSaveDraft();
              onClickSave();
              // console.log("ds");
            }}
          >
            {Role === RoleId.Admin ? "Save" : "Save Draft"}
          </ColorButton>
        )}

      {(statusId === "D" || Role === RoleId.Admin) &&
        !isSubmitPreapprove &&
        canEdit && (
          <ColorButton
            style={{ height: 40, width: 125, marginLeft: 20 }}
            variant="outlined"
            color="primary"
            disabled={isDisabledSaveDraftButton}
            onClick={onClickSaveDraft}
          >
            {Role === RoleId.Admin ? "Save" : "Save Draft"}
          </ColorButton>
        )}

      {statusId === "D" || (isSubmitPreapprove && statusId !== "FRVW")
        ? !hideSubmit &&
        !(
          Role === RoleId.Admin ||
          Role === RoleId.Staff ||
          Role === RoleId.Supervisor ||
          Role === RoleId.Director
        ) && (
          <ColorButton
            style={{ height: 40, width: 125, marginLeft: 20 }}
            variant="contained"
            color="primary"
            type="submit"
            disabled={isDisabledNextButton}
            onClick={() => {
              window.scrollTo(0, 0);
              if (lastpage) {
                // console.log(smartId);
                if (smartId === "AFQEFD") {
                  alert(
                    "Dependant(s) application has been submitted under your LTR Visa application.   Please click “approve” in the “Personal dependant” tab to allow the processing of your dependant(s) application.  "
                  );
                  onClickSubmit();
                } else {
                  onClickSubmit();
                }
              } else {
                onClickNext();
              }
            }}
          >
            {lastpage ? "Submit" : nextButtonText}
          </ColorButton>
        )
        : null}
    </div>
  );
}
